import Vue from 'vue'
import Vue2Touch from 'vue2-touch'

Vue.use(Vue2Touch)

export default {}



// WEBPACK FOOTER //
// ./src/initializers/vue-touch.js